import React, { Component } from 'react';
import { APP_URL_API } from '../../setup/configs';
import axios from 'axios';
import Header from '../common/Header';
import withAuth from '../auth/withAuth';
import Input from '../../ui/input/Input';
import DonationFields from './DonationsFields';
import { labels } from './labels';
import ReactTooltip from 'react-tooltip';

const styles = {
    footerBar: {
      position:'fixed',
      bottom:'0',
      height: '7em',
      backgroundColor:'#33485c',
      width:'100%',
      zIndex: '10',
      textAlign: 'center'
    },
    footerButtons: {
      position: 'relative',
      transform: 'translate(-50%,-50%)',
      top: '50%',
      left: '50%'
    },
    fileinput: {
        width: '0.1px',
        height: '0.1px',
        opacity: 0,
        overflow: 'hidden',
        position: 'absolute',
        zIndex: -1
    },
    filelabel: {
        fontSize: '1em',
        fontWeight: 700,
        color: 'white',
        display: 'inline-block',
        padding: '.4em',
        margin: '0 0 .5em 0',
        cursor: 'pointer',
    },
  }

class ReportDonationsInfo extends Component {
    constructor(props) {
        super(props)

        this.state = {
            accept: false,
            donationsFile1: null,
            donationsFile2: null,
            donationsAccepted: null,
            donationsOver20000: null,
            totalAmount: "0",
            summary: "0",
            data: {
                person: [],
                other: []
            },
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevState.data != this.state.data) {
            this.setState(
                {
                    summary: this.calculateTotalAmounts(),
                }
            )
        }
        if(prevState.donationsAccepted != this.state.donationsAccepted && this.state.donationsAccepted === "option2") {
            this.setState({
                totalAmount: "0"
            })
        } 
    }
    
    calculateTotalAmounts = () => {
        const { person, other } = this.state.data;
    
        // Convert all values to numbers and sum the amounts
        const totalAmount = [
          ...person.map(([amount]) => amount),
          ...other.map(([amount]) => amount),
        ]
        .reduce((total, amount) => total + (typeof amount === 'string' ? parseFloat(amount.replace(',','.')) : amount), 0);

        return totalAmount;
      };

    convertData = () => {
        // Convert the data to the specified format
        const convertedData = {
          amountTotal: this.state.totalAmount.replace(',','.'),
          person: this.state.data.person.map(entry => ({
            name: entry[1],
            amount: typeof entry[0] === 'string' ? entry[0].replace(',','.') : entry[0]
          })),
          other: this.state.data.other.map(entry => ({
            name: entry[1],
            amount:  typeof entry[0] === 'string' ? entry[0].replace(',','.') : entry[0],
            address: entry[2],
            country: entry[3]
          })),
        };

        // Remove "person" and "other" arrays if they are empty
        if (convertedData.person.length === 0) {
            delete convertedData.person;
        }
        
        if (convertedData.other.length === 0) {
            delete convertedData.other;
        }

        return convertedData;
    }

    handleAddRow = (type) => {
        const newData = { ...this.state.data };
        
        type==='person' ? newData[type].push(["", "Anonym"]) :  newData[type].push(["", "","",""]);
        
        this.setState({
            data: newData
        });
    }

    handleDeleteRow = (arrayName, index) => {
        this.setState((prevState) => {
            const newData = { ...prevState.data };
            newData[arrayName] = newData[arrayName].filter((_, i) => i !== index);
            return { data: newData };
          });
    }

    handleInputChange = (type, rowIndex, colIndex, value) => {
        // Check if the validation should be applied (colIndex === 0)
        const shouldValidate = colIndex === 0;

        if (shouldValidate && !/^\d+(\,\d{0,2})?$/.test(value) && value !== "") {
          return; // Validation failed, exit the function
        }

        if(type==='person' && colIndex === 1) {
            return;
        }
      
        // If validation passed or not needed, update the state
        const newData = { ...this.state.data };
        newData[type][rowIndex][colIndex] = value;
      
        this.setState({
          data: newData,
        });
      };
      
    onSubmit = () => {
        if(this.state.donationsAccepted === null) {
            alert("Du mangler at tage stilling til om Menigheden/trossamfundet har modtaget donationer");
            return false;
        }
        if(this.state.accept === false) {
            alert("Du skal erklære på tro og love, at de indberettede oplysniger er korrekte");
            return false;
        }
        if((parseInt(this.state.totalAmount) - parseInt(this.state.summary)) < 0) {
            alert("Det samlede beløb for donationer over 20.000 kr. kan ikke overstige det samlede beløb modtaget i donationer. Tjek venligst de indtastede oplysninger");
            return false;
        }
        if(this.state.donationsAccepted === "option1" && this.state.totalAmount === "0") {
            alert("Når du har svaret ja til at menigheden/trossamfundet har modtaget donationer, skal feltet med oplysninger om det samlede donationsbeløb også udfyldes.");
            return false;
        }
        const { person, other } = this.state.data;

        const allValues = [
            ...person.flatMap(entry => entry.filter((_, index) => index === 0)).map(Number),
            ...other.flatMap(entry => entry.filter((_, index) => index === 0)).map(Number),
          ];

        const allStringValues = [
            ...person.flatMap(entry => entry.filter((_, index) => index > 0)),
            ...other.flatMap(entry => entry.filter((_, index) => index > 0)),
            ];  
        
        const allNameInOtherValues = [
            ...other.flatMap(entry => entry.filter((_, index) => index === 1)),
            ];  
        
        if(this.state.donationsOver20000 === "option1" && person.length === 0 && other.length === 0) {
            alert("Når du har svaret ja til at menigheden/trossamfundet har modtaget donationer over 20.000, skal 'Oplysninger om donatorer der har doneret over 20.000 kr.' også udfyldes.");
            return false;
        }

        // Check if any value is below 20000.01
        const isAnyValueBelowThreshold = allValues.some(value => value < 20000.01 || (typeof value === 'string' && value < "20000,01"));

        if(isAnyValueBelowThreshold) {
            alert("Et eller flere beløb er under kr. 20.000,01 - alle indtastede beløb skal være højere end kr. 20.000,01");
            return false;
        }
        
        const isAnyValueEmpty = allStringValues.some(value => value === "" || value === null);
    
        if(isAnyValueEmpty) {
            alert("Alle felter under skal udfyldes");
            return false;
        }

        // Check if word "Anonym" has been used as name where it is not allowed
        const isValueNotAllowed = allNameInOtherValues.some(value => value.toLowerCase() === "Anonym".toLowerCase());
        
        if(isValueNotAllowed) {
            alert("Donationer under 'Andre' må ikke indeholde donationer fra anonyme");
            return false;
        }

        const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};
        const organizationId = this.props.match.params.id;
        const year = this.props.match.params.year;
        const url = APP_URL_API + 'donations/organization/' + organizationId + '/year/' + year;

        const data = this.convertData();

        this.serverRequest =
        axios
            .post(url, data, {headers: config})
            .then(function(response) {
                this.props.history.replace('/admin/organization/' + this.props.match.params.id + '/edit');
            }.bind(this))
    }

    onChange = (e) => {
        if(e.target.type==="file") {
            if(e.target.files[0].type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                this.setState({
                    [e.target.name]: e.target.files[0]
                })
            } else {
                this.setState({
                    modalText: 'Forkert filtype. Kun EXCEL-filer tilladt.',
                    showAlertModal: true,
                    showModal: false
                });
                e.target.value = "";
            }
        } else if(e.target.type==="checkbox"){
            this.setState({
                [e.target.name]: e.target.checked
            })
        } else if(e.target.type==="radio"){
            this.setState({
                [e.target.name]: e.target.value
            })
        }
        else if(e.target.type==="text"){
            const shouldValidate = e.target.name === "totalAmount";
        
            if (shouldValidate && !/^\d+(\,\d{0,2})?$/.test(e.target.value) && e.target.value !== "") {
            return; // Validation failed, exit the function
            }

            this.setState({
                [e.target.name]: e.target.value
            })
        }
        e.target.value = '';
    }

    uploadDonationFile = (type) => {
        const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};
        const organizationID = this.props.match.params.id;
        const url = APP_URL_API + 'donations/' + type + '/upload-excel-and-get-data'; 

        const data = new FormData();
        const file = type==='person' ? this.state.donationsFile1 : this.state.donationsFile2;
        data.append("file", file);
        
        this.serverRequest =
        axios
            .post(url, data, {headers: config})
            .then(function(response) {
                this.setState((prevState) => ({
                    data: {
                        ...prevState.data,
                        [type]: response.data,
                    },
                    donationsFile1: null,
                    donationsFile2: null,
                }));
            }.bind(this))
    }

    onBackToOverview = () => {
        this.props.history.replace('/admin/organization/' + this.props.match.params.id + '/edit')
      }

    render() {
        const year = this.props.match.params.year;
        return (
            <div className="mb-36">
                <Header user={this.props.user} history={this.props.history}>
                {this.props.user.type === 'admin' && <nav className="navigation">
                    <ul className="navigation__list">
                    <li className="navigation__listitem"><a href="/admin/organizations/">Oversigt</a></li>
                    <li className={!this.props.match.params.id ? 'navigation__listitem active' : 'navigation__listitem '}><a href="/admin/organization/create">Opret</a></li>
                    <li className="navigation__listitem"><a href="/admin/organizations/settings">Indstillinger</a></li>
                    </ul>
                </nav>}
                </Header>

                <div className="container pt-4">
                    <h1>Indberetning af donationer</h1>

                    <DonationsAccepted onChange={this.onChange} donationsAccepted={this.state.donationsAccepted} />

                    {this.state.donationsAccepted === "option1" &&
                        <InformationTotalAmount onChange={this.onChange} totalAmount={this.state.totalAmount} />
                    }

                    {this.state.donationsAccepted === "option1" &&
                        <InformationAboutDonationsOver20000 onChange={this.onChange} donationsOver20000={this.state.donationsOver20000} />
                    }

                    {this.state.donationsAccepted === "option1" && this.state.donationsOver20000 == "option1" &&
                        <div>
                            <h2>{labels.header4}</h2>
                            <div>{labels.text4}</div>
                            <DonationFields 
                                data={this.state.data.person} 
                                year={year}  
                                donationsFile={this.state.donationsFile1}
                                handleInputChange={this.handleInputChange}
                                onChange={this.onChange}
                                type="person"
                                uploadDonationFile={() => this.uploadDonationFile('person')}
                                handleAddRow={(type) => this.handleAddRow(type)}
                                handleDeleteRow={(arrayName, index) => this.handleDeleteRow(arrayName, index)}
                            />
                        
                            <DonationFields 
                                data={this.state.data.other} 
                                year={year}  
                                donationsFile={this.state.donationsFile2}
                                handleInputChange={this.handleInputChange}
                                onChange={this.onChange}
                                type="other"
                                uploadDonationFile={() => this.uploadDonationFile('other')}
                                handleAddRow={(type) => this.handleAddRow(type)}
                                handleDeleteRow={(arrayName, index) => this.handleDeleteRow(arrayName, index)}
                            />
                        </div>
                    }

                    {this.state.donationsAccepted === "option1" &&
                        <Summary totalAmount={this.state.totalAmount} summary={this.state.summary} />
                    }

                    {this.state.donationsAccepted !== null &&
                        <AcceptConditions accept={this.state.accept} onChange={this.onChange} />
                    }

                </div>
                <Footer onBackToOverview={this.onBackToOverview} onSubmit={this.onSubmit} />
            </div>
        )
    }
}

export default withAuth(ReportDonationsInfo);

const Footer = (props) => {
    return(
        <div style={styles.footerBar}>
            <div style={styles.footerButtons}>
                <button className="button large sienna button--footer" type="button" onClick={props.onBackToOverview}>Tilbage</button>
                <button className="button large summer button--footer" type="button" onClick={props.onSubmit}>Indberet</button>
            </div>
        </div>
    )
}

const Summary = (props) => {
    const formatter = new Intl.NumberFormat('da-DK', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

    const totalAmount = props.totalAmount.replace(',','.');
    const summary = props.summary;
    const difference = totalAmount - summary;
    
    return (
        <div className="flex flex-col gap-4 bg-lightgrey rounded my-6 py-8">
            <div className="mx-8">
                <h2>{labels.header6}</h2>
                <div>{labels.text6.label1}</div>
                <div className="summaryField">{formatter.format(totalAmount)}</div>
                <div>{labels.text6.label2}</div>
                <div className="summaryField">{formatter.format(summary)}</div>
                <div>{labels.text6.label3}</div>
                <div className={parseInt(difference) < 0 ? 'summaryField summaryField--negative' : 'summaryField'}>{formatter.format(difference)}</div>
                {parseInt(difference) < 0 && <div className="text-red font-bold">Det samlede beløb for donationer over 20.000 kr. kan ikke overstige det samlede beløb modtaget i donationer. Tjek venligst de indtastede oplysninger</div>}
            </div>
        </div>
    )
}

const InformationTotalAmount = (props) => {
    return (
        <div className="flex flex-col gap-4 bg-lightgrey rounded my-6 py-8">
            <div className="mx-8">
                <h3>{labels.header2}</h3>
                <div>
                    <label>
                        <Input type="text" name="totalAmount" value={props.totalAmount} onChange={props.onChange} placeholder="Samlet beløb *" />
                    </label>
                </div>
                <p>{labels.infoText2}</p>
            </div>
        </div>
    )
}

const DonationsAccepted = (props) => {
    return (
        <div>
            <h3>{labels.header1}</h3>
            <p>{labels.text1}</p>
            <div>
                <label>
                    <input type="radio" name="donationsAccepted" value="option1" onChange={props.onChange} checked={props.donationsAccepted === "option1"} /> Ja
                </label>
            </div>
            <div>
                <label>
                    <input type="radio" name="donationsAccepted" value="option2" onChange={props.onChange} checked={props.donationsAccepted === "option2"} /> Nej
                </label>
            </div>
        </div>
    )
}

const InformationAboutDonationsOver20000 = (props) => {
    return (
        <div className="flex flex-col gap-4 bg-lightgrey rounded my-6 py-8">
            <ReactTooltip />
            <div className="mx-8">
                <h3 className="flex items-center gap-4">{labels.header3} <img src="/images/assets/info.svg" alt="info" data-html={true} data-tip="Trossamfundet/menigheder skal hvert år indberette oplysninger om, hvorvidt der i<br/> regnskabsåret er modtaget en eller flere donationer fra samme donator, der enkeltvis<br/> eller samlet overstiger 20.000 kr." /></h3>
                <p>{labels.text3}</p>
                <div>
                    <label>
                        <input type="radio" name="donationsOver20000" value="option1" onChange={props.onChange} checked={props.donationsOver20000 === "option1"} /> Ja
                    </label>
                </div>
                <div>
                    <label>
                        <input type="radio" name="donationsOver20000" value="option2" onChange={props.onChange} checked={props.donationsOver20000 === "option2"} /> Nej
                    </label>
                </div>
            </div>
        </div>
    )
}

const AcceptConditions = (props) => {
    return (
        <div className="my-6">
            <div>
                <label>
                    <input type="checkbox" name="accept" onChange={props.onChange} checked={props.accept} />
                    Jeg erklærer hermed på tro og love, at de indberettede oplysninger er korrekte og i overensstemmelse med de gældende regler for anerkendte trossamfund, samt at jeg i henhold til § 7, stk. 2, nr. 4, i lov nr. 1533 af 19. december 2017 om trossamfund uden for folkekirken er berettiget til på trossamfundets/menighedens vegne at foretage indberetningen.
                </label>
                <p>By-, Land- og Kirkeministeriet gør opmærksom på, at de indberettede oplysninger vises på Trossamfundsregistrets hjemmeside, jf. § 21, stk. 1 og 2, jf. § 11, i lov nr. 1533 af 19. december 2017 om trossamfund uden for folkekirken.</p> 
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/modules/reports/ReportDonationsInfo.js